export default "__VITE_ASSET__CD8HT9E$__"